import { endPoint } from "./base.config";

export const globalRule = {
  add: `${endPoint}globalRules`,
  update: `${endPoint}globalRules/:id`,
  delete: `${endPoint}globalRules/:id`,
  fetchAll: `${endPoint}globalRules`,
}